import { useEffect, useState } from "react";
import "./portal.css";
import { configuration } from "../../utils/configuration";
import { walkthroughs } from "./walkthrough";

export default function Portal() {
  const [availableHeight, setAvailableHeight] = useState("100vh");

  useEffect(() => {
    const header = document.getElementById("app-header");
    const footer = document.getElementById("app-footer");

    const computeHeight = () => {
      const headerH = header?.offsetHeight || 0;
      const footerH = footer?.offsetHeight || 0;
      setAvailableHeight(`calc(100vh - ${headerH + footerH}px)`);
    };

    // run once + on resize
    computeHeight();

    const resizeObserver = new ResizeObserver(computeHeight);
    if (header) resizeObserver.observe(header);
    if (footer) resizeObserver.observe(footer);
    window.addEventListener("resize", computeHeight);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", computeHeight);
    };
  }, []);

  useEffect(() => {
    const js_scripts = [configuration, ...walkthroughs];

    const loadedScripts = js_scripts.map((script) => {
      const scriptElement = document.createElement("script");
      scriptElement.src = script.src;
      if (script.async !== undefined) scriptElement.async = script.async;
      if (script.defer !== undefined) scriptElement.defer = script.defer;
      if (script.onload) scriptElement.onload = script.onload;
      document.head.appendChild(scriptElement);
      return scriptElement;
    });

    return () => {
      loadedScripts.forEach((script) => {
        document.head.removeChild(script);
      });
    };
  }, []);

  return (
    <div
      id="apimatic-widget"
      className="widget-container"
      style={{ height: availableHeight }}
    />
  );
}
